import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { EntitiesServiceService } from '../../../../../services/entities-service.service';

@Component({
  selector: 'app-reminders',
  templateUrl: './reminders.component.html',
  styleUrls: ['./reminders.component.css']
})
export class RemindersComponent implements OnInit, OnDestroy {
  @Input() entityId: any;
  @Input() widgetData: any;
  reminderData: any;
  isloader: boolean = true;
  isError: boolean = false;
  tenantDetails: any;
  private _getReminderDetailsSubscription: Subscription;

  
  constructor( private _service: EntitiesServiceService, private _sharedService: ServicecallService) { }

  ngOnInit(): void {
    this.tenantDetails = this._sharedService.getConfiguration('tenantGenericConfig') ? this._sharedService.getConfiguration('tenantGenericConfig') : null;
    this._getReminderData();
  }
  ngOnDestroy(): void {
    this._getReminderDetailsSubscription?.unsubscribe(); 
  }
  private _getReminderData() {
    this._getReminderDetailsSubscription = this._service.getReminderDetails({ entityId: this.entityId }).subscribe(
      {
        next: (result: any) => {
          if (result.status) {
            this.reminderData = result.response.data[0];
            this.isloader = false;
          }
        },
        error: (error) => {
          if (error) {
            this.isloader = false;
            this.isError = true;
          }
        }
      }
    )
  }

}
